import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { InscriptionPage } from '../pages/InscriptionPage';
import { WalletInscriptionPage } from '../pages/WalletInscriptionPage';
import { WalletFormPage } from '../pages/WalletFormPage';
import { ConfirmationPage } from '../pages/ConfirmationPage';

export const AppRoutes: React.FC = () => {
  return (
    <BrowserRouter>
      <Routes>
        {/* Nueva ruta para forms/:form/wallets/:wallet */}
        <Route path="/forms/:form/wallets/:wallet" element={<WalletFormPage />} />
        
        {/* Rutas legacy para mantener compatibilidad */}
        <Route path="/templates/:id/wallets/:wallet" element={<WalletInscriptionPage />} />
        <Route path=":id/wallets/:wallet" element={<WalletInscriptionPage />} />
        
        {/* Ruta para confirmaciones legacy wallets/:wallet/confirmation */}
        <Route path="/wallets/:wallet/confirmation" element={<ConfirmationPage />} />
        
        <Route path="/templates/:id" element={<InscriptionPage />} />
        <Route path="/:id" element={<InscriptionPage />} />
        <Route path="/" element={<InscriptionPage />} />
      </Routes>
    </BrowserRouter>
  );
}; 